import type { UUID, WifiSettings, WifiSettingsRequest } from '@cobliteam/common-types';
import camelcaseKeys from 'camelcase-keys';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class CameraConfigurationRequester {
  private requester: Requester;

  private readonly baseUrl: string;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
    this.baseUrl = 'cameras/configuration/wifi';
  }

  public createWifiSettings = async ({ ssid, password }: WifiSettingsRequest): Promise<WifiSettings> => {
    const requestData: IRequest = {
      endpoint: this.baseUrl,
      method: HttpMethod.POST,
      body: JSON.stringify({
        ssid,
        password,
      }),
    };

    const { data } = await this.requester.request(requestData);

    return camelcaseKeys(data);
  };

  public editWifiSettings = async ({ id, ssid, password }: WifiSettingsRequest): Promise<WifiSettings> => {
    const requestData: IRequest = {
      endpoint: this.baseUrl,
      method: HttpMethod.PATCH,
      body: JSON.stringify({
        id,
        ssid,
        password,
      }),
    };

    const { data } = await this.requester.request(requestData);

    return camelcaseKeys(data);
  };

  public deleteWifiSettings = async (id: UUID): Promise<void> => {
    const requestData: IRequest = {
      endpoint: `${this.baseUrl}/${id}`,
      method: HttpMethod.DELETE,
    };

    this.requester.request(requestData);
  };
}

export default CameraConfigurationRequester;
